<template>
  <div class="map-view">
    <div class="btn-group  no-print">
      <button
        class="btn btn-info"
        @click="toggleShowAllCurrentViewData"
      >{{showAllViewData?"show feeder":"show all"}}</button>
    </div>

    <div :id="mapDivId" class="col-12 my-map"></div>
  </div>
</template>

<script>
import { MapTls } from "../../src/app/tools/MapTls";
import { ApiTls } from "../../src/app/tools/ApiTls";
import { v4 as uuidv4 } from "uuid";
import { Drawer } from "../app/drawer/Drawer";
import { BoundTls } from "../app/tools/BoundTls";

//  TODO fit base on props on bound or on col and row + tol
export default {
  name: "MapView",
  props: ["mainObj"],
  data() {
    return {
      mapDivId: "mapid-" + uuidv4(),
      showAllViewData: false,
      mapDrawnData: {},
    };
  },
  methods: {
    draw() {
      if (this.mymap && this.mainObj && this.mainObj != {}) {
        this.mymap.clearLayers();
        BoundTls.resetMinMaxBound();
        this.mapDrawnData = Drawer.drawAll(this.mymap, this.mainObj);
        MapTls.fitTo(this.mymap);
        MapTls.typeBounds(document, this.mymap);
      }
    },
    toggleShowAllCurrentViewData() {
      if (this.showAllViewData) this.draw();
      else ApiTls.getAllCurrentViewData(this.mymap);
      this.showAllViewData = !this.showAllViewData;
    },
    onMapClick(e){
        console.log(e.target);
        console.log(e.layer);
        console.log(e);

        // var popup = L.popup();
        // popup
        // .setLatLng(e.latlng)
        // .setContent("You clicked the map at " + e.latlng.toString())
        // .openOn(mymap);
    }
  },
  mounted() {
    this.mymap = MapTls.initMap(this.mapDivId);
  },
  watch: {
    mainObj() {
      this.draw();
    },
  },
};
</script>





<style scoped>
.my-map {
  min-height: 100vh;
  width: 100%;
}
.my-map > button {
  margin-left: 100px;
  margin-right: auto;
}
.leaflet-container {
  background: #fff;
  outline: 0;
}

.leaflet-popup-tip-container {
  display: none;
}

body.printable .my-map {
  min-height: 190mm;
  /* height: 100%;
    width: 50%;
    position: absolute;
    right: 10mm;
    top: 10mm; */
}
/* body.printable sheet{
position: relative;
} */
</style>